
export default function FinalCtaSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-600 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          {/* Urgency badge */}
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-red-500/20 border border-red-500/30 rounded-full mb-8">
            <i className="ri-time-line text-xl text-red-400"></i>
            <span className="text-red-300 font-semibold text-sm">
              今月の無料相談枠 残り3枠
            </span>
          </div>

          <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
            東京の民泊運営を、<br />
            プロに任せてみませんか？
          </h2>
          <p className="text-xl text-gray-300 mb-4 leading-relaxed">
            無料相談では、あなたの物件に最適な運営プランと<br />
            収益シミュレーションを詳しくご提案します
          </p>
          <p className="text-sm text-gray-400">
            所要時間：30分〜1時間 / オンライン・対面どちらでもOK
          </p>
        </div>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="#contact"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-teal-600 text-white rounded-full font-bold text-lg hover:bg-teal-500 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-2xl"></i>
            無料相談を予約する
          </a>
          <a
            href="tel:+81-3-1234-5678"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-white/10 text-white border-2 border-white/30 rounded-full font-bold text-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-2xl"></i>
            電話で相談する
          </a>
        </div>

        {/* Benefits grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 transition-colors">
            <div className="w-16 h-16 bg-teal-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-teal-400"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">
              安心の実績
            </h3>
            <p className="text-gray-400 text-sm">
              平均稼働率92%、150件以上の運営実績
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 transition-colors">
            <div className="w-16 h-16 bg-teal-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-teal-400"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">
              24時間サポート
            </h3>
            <p className="text-gray-400 text-sm">
              トラブル時も即座に対応、安心の運営体制
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 transition-colors">
            <div className="w-16 h-16 bg-teal-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-hand-coin-line text-3xl text-teal-400"></i>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">
              初期費用0円
            </h3>
            <p className="text-gray-400 text-sm">
              リスクなく始められる、成果報酬型プラン
            </p>
          </div>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-8 pt-8 border-t border-white/10">
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-1">92%</div>
            <div className="text-sm text-gray-400">平均稼働率</div>
          </div>
          <div className="w-px h-12 bg-white/10"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-1">4.9</div>
            <div className="text-sm text-gray-400">レビュー評価</div>
          </div>
          <div className="w-px h-12 bg-white/10"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-1">150+</div>
            <div className="text-sm text-gray-400">対応件数</div>
          </div>
          <div className="w-px h-12 bg-white/10"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white mb-1">3年+</div>
            <div className="text-sm text-gray-400">運営実績</div>
          </div>
        </div>

        {/* 決済の流れ */}
        <div className="mt-10 pt-8 border-t border-white/10">
          <p className="text-sm font-semibold text-gray-400 tracking-widest uppercase text-center mb-8">
            決済の流れ
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              {
                step: '01',
                icon: 'ri-calendar-check-line',
                title: '無料相談を予約',
                desc: 'フォームまたはお電話でご予約。費用は一切かかりません。',
                badge: null,
              },
              {
                step: '02',
                icon: 'ri-discuss-line',
                title: '相談・プラン確定',
                desc: '物件に最適なプランをご提案。ご納得いただいてから契約へ。',
                badge: null,
              },
              {
                step: '03',
                icon: 'ri-file-text-line',
                title: '契約・カード登録',
                desc: '契約締結後、PAY.JP（決済代行）にてカード情報をご登録。SSL暗号化で安全に処理されます。',
                badge: 'カード入力はここ',
              },
              {
                step: '04',
                icon: 'ri-shield-check-line',
                title: '自動決済・運営開始',
                desc: '毎月の管理費は自動引き落とし。手間なく運営をスタート。',
                badge: null,
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="relative bg-white/5 border border-white/10 rounded-2xl p-5 flex flex-col gap-3 hover:bg-white/10 transition-colors"
              >
                {/* Step number */}
                <span className="text-xs font-bold text-teal-400 tracking-widest">STEP {item.step}</span>

                {/* Icon */}
                <div className="w-10 h-10 flex items-center justify-center bg-teal-600/20 rounded-full">
                  <i className={`${item.icon} text-xl text-teal-400`}></i>
                </div>

                {/* Title */}
                <h4 className="text-sm font-bold text-white leading-snug">{item.title}</h4>

                {/* Description */}
                <p className="text-xs text-gray-400 leading-relaxed">{item.desc}</p>

                {/* Badge */}
                {item.badge && (
                  <span className="inline-flex items-center gap-1 px-2 py-1 bg-teal-500/20 border border-teal-500/40 rounded-full text-teal-300 text-xs font-semibold w-fit">
                    <i className="ri-bank-card-line text-xs"></i>
                    {item.badge}
                  </span>
                )}

                {/* Connector arrow (not on last item) */}
                {idx < 3 && (
                  <div className="hidden md:flex absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center z-10">
                    <i className="ri-arrow-right-s-line text-xl text-teal-500"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Security note */}
          <div className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-500">
            <i className="ri-lock-line text-teal-500 text-sm"></i>
            <span>SSL暗号化通信・PCI DSS準拠。カード情報は安全に保護されます。</span>
          </div>
        </div>

        {/* お支払い方法 */}
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col items-center gap-4">
          <p className="text-sm font-semibold text-gray-400 tracking-widest uppercase">
            ご利用可能なお支払い方法
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            {/* Visa */}
            <div className="flex items-center justify-center px-4 py-2 rounded-lg bg-white shadow-md" style={{ minWidth: '72px', height: '40px' }}>
              <span className="font-extrabold text-base tracking-tight" style={{ color: '#1A1F71', fontFamily: 'Arial, sans-serif' }}>VISA</span>
            </div>
            {/* Mastercard */}
            <div className="flex items-center justify-center gap-0.5 px-4 py-2 rounded-lg bg-white shadow-md" style={{ minWidth: '72px', height: '40px' }}>
              <div className="w-6 h-6 rounded-full" style={{ backgroundColor: '#EB001B' }}></div>
              <div className="w-6 h-6 rounded-full -ml-3" style={{ backgroundColor: '#F79E1B' }}></div>
            </div>
            {/* JCB */}
            <div className="flex items-center justify-center px-4 py-2 rounded-lg bg-white shadow-md" style={{ minWidth: '72px', height: '40px' }}>
              <span className="font-extrabold text-base" style={{ color: '#003087', fontFamily: 'Arial, sans-serif' }}>JCB</span>
            </div>
            {/* American Express */}
            <div className="flex items-center justify-center px-4 py-2 rounded-lg shadow-md" style={{ backgroundColor: '#2E77BC', minWidth: '72px', height: '40px' }}>
              <span className="font-extrabold text-sm text-white" style={{ fontFamily: 'Arial, sans-serif', letterSpacing: '0.5px' }}>AMEX</span>
            </div>
          </div>
          <p className="text-xs text-gray-500">クレジットカード決済に対応しています</p>
        </div>
      </div>
    </section>
  );
}